/* eslint import/prefer-default-export: "off" */
import styled from 'styled-components'

export const StyledTableWrapper = styled.div`
  display:flex
  flex-direction: column
  width:100%
  flex:1
  max-height: calc(100vh-296px)
`
